<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Agrani Bank,Main Branch-New User</div>
        <div>
          <bread-crumb
            :bread-crumbs="[
              'Partner Summary',
              'Partner Branch',
              'User Detail',
              'New User',
            ]"
          />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <!-- <v-row class="mt-2 ms-1 me-1">
                <v-col cols="12" md="6">
                    <h3 class="labelFontsize  mb-0 mt-2 mb-4">Agrani Bank,Main Branch-New User</h3>

                </v-col>

            </v-row> -->
      <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Login ID</label>
          <v-text-field outlined dense class="rounded" placeholder="Login Id">
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Name</label>
          <v-autocomplete outlined dense class="rounded" placeholder="Name">
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Post</label>
          <v-autocomplete outlined dense class="rounded" placeholder="Post">
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Address</label>
          <v-autocomplete outlined dense class="rounded" placeholder="Address">
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Email</label>
          <v-text-field outlined dense class="rounded" placeholder="Email">
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Mobile Number</label>
          <v-autocomplete
            outlined
            dense
            class="rounded"
            placeholder="Mobile Number"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Branch Name</label>
          <v-autocomplete
            outlined
            dense
            class="rounded"
            placeholder="Branch Name"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">View Pass Trans.Limit</label>
          <v-autocomplete
            outlined
            dense
            class="rounded"
            placeholder="View Press Trans Limit"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0"
            >Must Required 2 Factor Authentification</label
          >
          <v-text-field
            outlined
            dense
            class="rounded"
            placeholder="Must Required Two Factor Authentification"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Deactive User</label>
          <v-autocomplete
            outlined
            dense
            class="rounded"
            placeholder="Deactive User"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Remarks</label>
          <v-textarea outlined dense class="rounded" placeholder="Remarks">
          </v-textarea>
        </v-col>
      </v-row>
      <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Roles</label>
        </v-col>
      </v-row>
      <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="2">
          <v-checkbox label="Branch Manager"></v-checkbox>
        </v-col>
        <v-col cols="12" md="2">
          <v-checkbox label="Traior"></v-checkbox>
        </v-col>
      </v-row>
      <div class="row">
        <div class="col-md-12" style="display: flex; justify-content: end">
          <v-btn depressed  class="text-capitalize me-3 mb-10" color="primary"><v-icon small>mdi-content-save-plus-outline</v-icon>Add</v-btn>
          <v-btn depressed  class="text-capitalize me-5 mb-10" color="primary" outlined
            ><v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel</v-btn
          >
        </div>
      </div>
    </v-card>
  </section>
</template>
<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";

export default {
  name: "New User",

  data: () => {
    return {};
  },

  mounted() {
    this.getRemitteList();
  },

  components: {
    BreadCrumb,
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
